module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.2a891a2f.eot";